import React, { Component } from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

import Button from 'components/Button';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import CountryLabel from 'components/CountryLabel';
import ExportButton from 'components/Export';
import ListHeader from 'components/List/Header';
import ListRow from 'components/List/Row';
import Pills from 'components/Pills';
import Tooltip from 'components/Tooltip';
import ChartInputsBloc from 'modules/Distribution/components/ChartInputsBloc';

const ReferencesListContainer = styled.div`
  position: relative;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: ${(props) => props.theme.colors.dark};

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .row > *:not(:last-child) {
    margin-right: 15px;
  }

  .titleContainer {
    display: flex;
    height: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    width: calc(60% - 20px);
    padding-left: 20px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    line-height: 20px;

    text-decoration: none;
    color: ${(props) => props.theme.colors.dark};
  }

  .titleContainerPremium {
    width: calc(30% - 20px);
  }

  .countryContainer {
    height: 100%;
    width: 20%;
    justify-content: center;
  }

  .priceContainer {
    font-size: 12px;
    height: 100%;
    width: 20%;
    justify-content: center;
  }

  .priceContainerPremium {
    width: 17.5%;
  }

  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    width: 200px;
  }

  .refTitleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin-right: 5px;
    }

    .tooltipContainer {
      margin-right: 10px;
    }

    div {
      text-transform: none;
    }
  }

  .selectedWine {
    margin-bottom: 20px;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};

    span {
      opacity: 0.5;
    }
  }

  @media (max-width: 1600px) {
    > div:first-child {
      flex-direction: column !important;
      align-items: flex-start;
    }

    .exportButton {
      position: absolute;
      top: -5px;
      right: 0;
    }

    .row {
      margin-top: 10px;
    }

    .cardHeaderRight {
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

class ReferencesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
      sorted: 'price',
      desc: true
    };
  }

  handleChange(value) {
    this.setState((state) => ({
      price: state.price.map((pill) => ({
        ...pill,
        active: pill.value === value
      }))
    }));
  }

  filterData(data) {
    let filteredData = [...data];
    const { vintage } = this.props;

    filteredData = vintage
      ? filteredData.filter((item) => item.vintage === vintage.value)
      : filteredData;

    return filteredData;
  }

  sortData(data) {
    const { sorted, desc } = this.state;
    data = data.sort(function (a, b) {
      if (!isNaN(a[sorted]) && !isNaN(b[sorted])) {
        return Number(a[sorted]) - Number(b[sorted]);
      } else {
        return String(a[sorted]).localeCompare(String(b[sorted]));
      }
    });
    if (!desc) {
      return data.reverse();
    }
    return data;
  }

  render() {
    const {
      data,
      retractedSize,
      vintage,
      handleVintage,
      exportOptions,
      premium,
      optionsFormat,
      vintageOptions,
      wine,
      handleChangeFormat
    } = this.props;
    const { showAll } = this.state;
    let filteredData = this.filterData(data);
    filteredData = this.sortData(filteredData);
    let subSetData = showAll
      ? filteredData
      : filteredData.slice(0, retractedSize);

    return (
      <Card className="card" id="vente-en-ligne-prix-references">
        <ReferencesListContainer>
          <CardHeader
            alignItems="center"
            title={
              <div className="refTitleContainer">
                <p>{I18n.t('onlineSales.referencesTitle')}</p>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  className="ignored-export"
                >
                  <div className="tooltipContainer">
                    <Tooltip
                      iconColor="#aaa"
                      placement="top"
                      content={<p>{I18n.t('onlineSales.referencesTooltip')}</p>}
                    />
                  </div>
                  <Pills
                    options={optionsFormat}
                    onChange={(format) => handleChangeFormat(format)}
                    styles={`justify-content: space-between;`}
                  />
                </div>
              </div>
            }
            styles={`.cardHeaderRight{width:100%; justify-content: flex-end;};flex-direction:row;align-items:center;`}
            fontSize="18px"
            iconRight="right"
            rightComponents={
              <div className="row ignored-export">
                <ChartInputsBloc
                  vintageStart={vintage}
                  noVintageEnd={true}
                  vintageOptions={vintageOptions}
                  onChange={(field, value) => handleVintage(value)}
                />
                <div className="exportButton">
                  <ExportButton
                    name={`${I18n.t('onlineSales.referencesTitle')}-${
                      get(exportOptions, 'market')
                        ? get(exportOptions, 'market.value')
                        : I18n.t('placeholderAll')
                    }-${get(exportOptions, 'date')}-${get(
                      exportOptions,
                      'wine.label'
                    )}`}
                    jpg
                    pdf
                    xls
                    path={`/web/premium/refs/xls?wines=["${get(
                      exportOptions,
                      'wine.label'
                    )}"]${
                      get(exportOptions, 'market')
                        ? '&market=' + get(exportOptions, 'market.value')
                        : ''
                    }`}
                    targetElement="#vente-en-ligne-prix-references"
                    newApi
                  />
                </div>
              </div>
            }
          />
          {premium && (
            <div className="selectedWine">
              {I18n.t('onlineSales.selectedWine')} : <span>{wine}</span>
            </div>
          )}
          <ListHeader
            columns={
              premium
                ? [
                    {
                      length: '32.5%',
                      name: I18n.t('onlineSales.referencesColumns.pos'),
                      sort: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'store_name',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.country'),
                      length: '12.5%',
                      sort: true,
                      center: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'market_country_code',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.localPrice'),
                      length: 'calc(20% - 20px)',
                      sort: true,
                      padding: 20,
                      onSort: () =>
                        this.setState({
                          sorted: 'local_price',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.price'),
                      length: '15%',
                      sort: true,
                      center: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'price',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.pmc'),
                      sort: true,
                      // eslint-disable-next-line no-dupe-keys
                      length: 'calc(20% - 20px)',
                      padding: 20,
                      onSort: () =>
                        this.setState({
                          sorted: 'pmc_dev',
                          desc: !this.state.desc
                        })
                    }
                  ]
                : [
                    {
                      length: '60%',
                      name: I18n.t('onlineSales.referencesColumns.pos'),
                      sort: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'store_name',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.country'),
                      length: '20%',
                      sort: true,
                      center: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'market_country_code',
                          desc: !this.state.desc
                        })
                    },
                    {
                      name: I18n.t('onlineSales.referencesColumns.price'),
                      length: '20%',
                      sort: true,
                      center: true,
                      onSort: () =>
                        this.setState({
                          sorted: 'price',
                          desc: !this.state.desc
                        })
                    }
                  ]
            }
          />
          {subSetData.map((pos, index) => (
            <ListRow
              dark={index % 2 === 0}
              key={`subscriptionRow + ${index}`}
              height="auto"
              padding="10px 0"
            >
              {pos.url ? (
                <a
                  rel="noreferrer"
                  href={pos.url}
                  target="_blank"
                  className={`titleContainer ${
                    premium && 'titleContainerPremium'
                  }`}
                >
                  <p>{pos.store_name}</p>
                </a>
              ) : (
                <div
                  className={`titleContainer ${
                    premium && 'titleContainerPremium'
                  }`}
                >
                  <p>{pos.store_name}</p>
                </div>
              )}
              <div
                className={`countryContainer ${
                  premium && 'priceContainerPremium'
                }`}
              >
                {pos.market_country_code ? (
                  <CountryLabel
                    styleFlag={{ fontSize: 16 }}
                    name={pos.market_country_code}
                  />
                ) : (
                  <p> - </p>
                )}
              </div>
              {premium && (
                <div className="priceContainer priceContainerPremium">
                  <p>
                    {pos.local_price ? (
                      <p>
                        {pos.local_price.toLocaleString('fr-FR', {
                          style: 'currency',
                          currency: pos.local_currency || 'EUR',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })}{' '}
                      </p>
                    ) : (
                      <p> - </p>
                    )}
                  </p>
                </div>
              )}
              <div
                className={`priceContainer ${
                  premium && 'priceContainerPremium'
                }`}
              >
                <p>
                  {pos.price ? (
                    <p>
                      {pos.price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: pos.displayed_currency
                          ? pos.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}{' '}
                    </p>
                  ) : (
                    <p> - </p>
                  )}
                </p>
              </div>
              {premium && (
                <div className="priceContainer priceContainerPremium">
                  <p>
                    {pos.pmc_dev ? (
                      <p>
                        {(pos.pmc_dev * 100).toLocaleString('fr-FR', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2
                        })}{' '}
                        %
                      </p>
                    ) : (
                      <p> {pos.pmc_dev === 0 ? '0' : '-'} </p>
                    )}
                  </p>
                </div>
              )}
            </ListRow>
          ))}
          <div className="showAllContainer ignored-export">
            {!showAll && filteredData.length > retractedSize && (
              <Button
                width="200px"
                label={`${I18n.t('seeMore')} (+${
                  filteredData.length - retractedSize
                })`}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: true })}
              />
            )}
            {showAll && filteredData.length > retractedSize && (
              <Button
                width="200px"
                label={I18n.t('seeLess')}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: false })}
              />
            )}
          </div>
        </ReferencesListContainer>
      </Card>
    );
  }
}

export default ReferencesList;
